export default __webpack_public_path__ + "static/media/Mark-5-HUD-Pop-Up (3 Layers).5b659c3f.jpg";